
function sanitize(filename) {
    // clean filename
    // sanitize(' \t _124/=)(/&%$..jpg') -> '-_124_.jpg'
    return encodeURIComponent(
        filename
            .slice(0, 260)
            .toLowerCase()
            .replace(/\s+/g, '-')
            // https://stackoverflow.com/a/11653019
            .replace(/\u00fc/g, 'ue')
            .replace(/\u00e4/g, 'ae')
            .replace(/\u00f6/g, 'oe')
            .replace(/\u00df/g, 'ss')
            .replace(/\.+/g, '.')
            .replace(/[^0-9A-Z\._-]+/gi, '_')
    );
}

export default sanitize



// WEBPACK FOOTER //
// ./src/utils/sanitize.js